export const SEARCH_SLOT_ID = 'search-slot';
export const BYPASS_TO_MAIN_NAV = 'bypass-to-main-navigation';
export const BYPASS_TARGET_AFTER_MAIN_NAV = 'bypass-target-after-navigation';
export const BYPASS_TO_MAIN_SECTION = 'bypass-to-main-section';
